import { render, staticRenderFns } from "./TableAction.vue?vue&type=template&id=39a9d687"
import script from "./TableAction.vue?vue&type=script&lang=ts"
export * from "./TableAction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports